import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import * as _ from 'lodash-es';

/**
 * Replicates AngularJS chart rollover: loadJsonObject action_code 24naqb, saveJsonObject action_code b5cgu4.
 */
@Injectable({ providedIn: 'root' })
export class ChartRolloverMaintenanceService {
  private readonly LOAD_ACTION_CODE = '24naqb';
  private readonly SAVE_ACTION_CODE = 'b5cgu4';

  constructor(private http: HttpClient) {}

  loadChartKeyList(
    baseUrl: string,
    globalService: any,
    filterParams: any = {}
  ): Observable<any> {
    const globalParams = globalService?.globalParams ?? globalService ?? {};
    const merged = { ...globalParams, ...filterParams, action_code: this.LOAD_ACTION_CODE };
    let httpParams = new HttpParams();
    Object.keys(merged).forEach(key => {
      if (merged[key] !== undefined && merged[key] !== null) {
        httpParams = httpParams.set(key, merged[key].toString());
      }
    });
    return this.http.get<any>(`${baseUrl}/loadJsonObject`, { params: httpParams, withCredentials: true });
  }

  saveChartRollover(
    baseUrl: string,
    clobData: { PRIOR_YR_KEY: string; CURR_YR_CHART_CODE: string },
    clobSettings: { tax_year: number },
    globalService: any,
    filterParams: any = {},
    rowData: any = {}
  ): Observable<any> {
    const url = `${baseUrl}/saveJsonObject?action_code=${this.SAVE_ACTION_CODE}`;
    const globalParams = globalService?.globalParams ?? globalService ?? {};
    let params: any = _.merge({}, globalParams, filterParams);
    params = _.extend({ clob_data: JSON.stringify(clobData) }, params);
    params = _.extend({ clob_settings: JSON.stringify(clobSettings) }, params);
    params.is_issue_key_enabled = globalService?.is_issue_key_enabled || filterParams?.is_issue_key_enabled || 'N';
    if (rowData && (rowData.LEID || rowData.COMBINATION_KEY)) {
      const checkLockedbj = [{
        leid: rowData.LEID ?? '',
        cdr_number: rowData.CDR_NO ?? rowData.TAX_CODE ?? '',
        consol_group_key: String(rowData.CONSOL_GROUP_KEY ?? ''),
        reporting_period: String(rowData.REPORTING_PERIOD ?? '1'),
        combination_key: String(rowData.COMBINATION_KEY ?? ''),
        scenario_key: parseInt(filterParams?.scenario ?? globalParams?.scenario ?? '74', 10)
      }];
      params.checkLockedbj = JSON.stringify(checkLockedbj);
    }

    const urlEncoded = new URLSearchParams();
    Object.keys(params).forEach(key => {
      if (params[key] !== undefined && params[key] !== null) {
        urlEncoded.set(key, params[key].toString());
      }
    });
    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded'
    });
    return this.http.post<any>(url, urlEncoded.toString(), { headers, withCredentials: true });
  }
}
